<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon" 
        v-bind:show.sync="dialog"
        maxWidth="50%"
    >
        <template v-slot:form>
            <v-tabs class="ma-0" v-model="tab">
                <v-tab key="main">Dados Principais</v-tab>
                <v-tab key="work-regime">Regime de Trabalho</v-tab>
            </v-tabs>
            <v-tabs-items  v-model="tab">
                <v-tab-item key="main">
                    <v-container>
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <v-text-field autofocus :error="!!errors.name" :error-messages="errors.name" v-model="model.name" label="Nome*"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <FormsAutocomplete
                                        v-model="model.teacher_position_category_id"
                                        label="Categoria do Cargo"
                                        :error="errors.length > 0"  
                                        :error-messages="errors.teacher_position_category_id"
                                        store-action="teacherPositionCategory/ActionGetTeacherPositionCategories"
                                        item-text="name"
                                        item-value="id"
                                        load-data
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-text-field :error="!!errors.description" :error-messages="errors.description" v-model="model.description" label="Descrição"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <sys-select-hour-group
                                        :model.sync="model.hour_group_id"
                                        label="Grupo de Horário"
                                        clearable
                                        dense
                                    />
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <s-text-field dense code :error-messages="errors.code" v-model="model.code" label="Código"/>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-switch inset v-model="model.active" label="Ativa"></v-switch>
                                </v-col>
                            </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item key="work-regime">
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <sys-select-teacher-work-regime 
                                    :model.sync="model.teacher_work_regime_id"
                                    :error="errors.length > 0"  
                                    :errors="errors.teacher_work_regime_id"
                                    label="Regime de Trabalho"
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" sm="4">
                                    <v-text-field :error="!!errors.min_workload" :error-messages="errors.min_workload" v-model="model.min_workload" label="Carga Horária Mínima"/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                    <v-text-field :error="!!errors.max_workload" :error-messages="errors.max_workload" v-model="model.max_workload" label="Carga Horária Máxima"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-switch inset v-model="model.requires_complementary" label="Complementar CH"/>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-switch inset v-model="model.is_priority" label="Prioridade de Atribuição"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterTeacherPosition",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        tab: 0,
        
    }),
    created(){
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};
                this.tab = 0;

                if(!this.model.id){
                    this.model.min_workload = null;
                    this.model.max_workload = null;
                    this.model.requires_complementary = 0;
                    this.model.is_priority = 0;
                    this.model.active = true;
                }

            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-playlist-star"
        },
        title: {
            type: String,
            default: "Cargo do Professor"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('teacherPosition', ['ActionUpdateTeacherPosition', 'ActionCreateTeacherPosition']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, {institution_id: this.acesso.instituicao.id})

            if(edit) {
                this.ActionUpdateTeacherPosition(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateTeacherPosition(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>